import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import OnyxApi from "../../components/OnyxApi";
import affordableOptionLogoDark from "../../assets/images/affordable-option-logo-dark.png";

function Login({ dealerId, setDealerId, dealers, setDealers }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const [error, setError] = useState(null);
  const [showPasswordResetLink, setShowPasswordResetLink] = useState(false);

  // Redirect if user is already logged in
  useEffect(() => {
    if (user) {
      navigate("/vehicle-submission");
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const user = await OnyxApi("login", { email, password });
      setUser(user.data);
      if (dealers === null) {
        const dealersResponse = await OnyxApi(
          "dealers",
          { type: ["live", "demo"] },
          user.data.usertoken
        );
        const sortedDealers = dealersResponse.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setDealers(sortedDealers);
        if (dealerId === "") {
          setDealerId(sortedDealers[0].id);
        }
      }
      navigate("/vehicle-submission");
    } catch (error) {
      const passwordError = error.response?.data?.errors?.password;
      if (passwordError) {
        setError(passwordError);
        setShowPasswordResetLink(true);
      } else {
        setError(error.message);
        setShowPasswordResetLink(false);
      }
    }
  };

  return (
    <div className="login-page vh-100">
      <div className="container">
        <div className="d-flex">
          <div className="col-12">
            <img
              src={affordableOptionLogoDark}
              alt="Affordable Option Logo Dark"
              style={{ maxWidth: "270px" }}
            />
          </div>
        </div>
        <div className="d-flex pt-5">
          <div className="col-md-4 offset-md-2 col-xl-3">
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
                {showPasswordResetLink && (
                  <>
                    {" "}
                    Go to the{" "}
                    <a
                      href="https://onyx.tripac.net/password/reset"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Onyx admin platform
                    </a>{" "}
                    to reset your password.
                  </>
                )}
              </div>
            )}
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="visually-hidden">Email</label>
                <input
                  type="email"
                  placeholder="Email"
                  className="form-control mb-4"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="visually-hidden">Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  className="form-control mb-4"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-lg text-900 py-0 px-5"
              >
                Sign In
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
